// extracted by mini-css-extract-plugin
export var container = "V_b";
export var content = "V_bQ";
export var icon = "V_bv";
export var iconContainer = "V_b3";
export var icons = "V_bw";
export var image = "V_g";
export var label = "V_c8";
export var section = "V_d";
export var text = "V_cm";
export var title = "V_h";